export default __webpack_public_path__ + "static/media/cara-kerja-1.e23a2a52.png";